import { UIScreenOptions, UIScreen } from '../ui/screen';
import { ABFooter } from './footer';

interface ABScreenOptions extends UIScreenOptions {
    no_footer?: boolean;
}

export abstract class ABScreen extends UIScreen {
    protected tl_footer?: ABFooter;

    constructor(options: ABScreenOptions) {
        let footer: ABFooter | undefined;

        if(!options.no_footer)
            options.footer = footer = new ABFooter;

        super(options);
        this.tl_footer = footer;
    }
}
